/**
 * Green Brothers — pizza UFO arrival and click-to-replay.
 */
(() => {
  const root = document.querySelector('[data-gb-craft]');
  if (!root) return;

  const fly = root.querySelector('.gb-craft__fly');
  const hit = root.querySelector('[data-gb-craft-replay]');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  let parked = root.classList.contains('is-parked');

  const remember = () => {
    if (designMode) return;
    try {
      sessionStorage.setItem('gb-craft-seen', '1');
    } catch (err) {
      /* private mode */
    }
  };

  const park = () => {
    parked = true;
    root.classList.remove('is-launching');
    root.classList.add('is-parked');
    remember();
  };

  const launch = () => {
    if (reduce || !fly) return;
    if (root.classList.contains('is-launching')) return;

    parked = false;
    root.classList.remove('is-parked');
    root.classList.remove('is-launching');
    void root.offsetWidth;
    root.classList.add('is-launching');
  };

  if (fly) {
    fly.addEventListener('animationend', (event) => {
      if (event.target !== fly) return;
      park();
    });
  }

  if (hit) {
    hit.addEventListener('click', (event) => {
      event.preventDefault();
      launch();
    });
  }

  if (!reduce && !parked) {
    window.addEventListener(
      'scroll',
      () => {
        if (window.scrollY > 90) park();
      },
      { passive: true }
    );
  }

  const io = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      root.classList.toggle('is-offscreen', Boolean(entry) && !entry.isIntersecting);
    },
    { threshold: 0 }
  );
  io.observe(root);
})();
